export enum JobSearchTab {
  Filters = '1',
  SavedSearches = '2',
}
